import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction
} from "react";

export interface LoanApplicationNavbarData {
  applicantName: string;
  loanApplicationID: string;
  loanApplicationNum?: string;
  actions?: Array<{ isShow: boolean; value: ReactNode }>;
  detailsSidebarData?: {
    details: any;
    selfie?: string;
    config: any;
    items: any[];
    isMFLLAP?: boolean;
  };
}

interface LoanApplicationNavbarContextType {
  loanData: LoanApplicationNavbarData | null;
  setLoanData: Dispatch<SetStateAction<LoanApplicationNavbarData | null>>;
}

const LoanApplicationNavbarContext = createContext<
  LoanApplicationNavbarContextType | undefined
>(undefined);

export function LoanApplicationNavbarProvider({
  children
}: {
  children: ReactNode;
}) {
  const [loanData, setLoanData] = useState<LoanApplicationNavbarData | null>(
    null
  );

  return (
    <LoanApplicationNavbarContext.Provider value={{ loanData, setLoanData }}>
      {children}
    </LoanApplicationNavbarContext.Provider>
  );
}

export function useLoanApplicationNavbar() {
  const context = useContext(LoanApplicationNavbarContext);
  if (context === undefined) {
    throw new Error(
      "useLoanApplicationNavbar must be used within a LoanApplicationNavbarProvider"
    );
  }
  return context;
}
